import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy text-white py-12" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-121">
          {/* Column 1: Company & General */}
          <div data-id="element-122">
            <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-123">Company</h3>
            <ul className="space-y-2" data-id="element-124">
              <li data-id="element-125">
                <a href="./" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-126">
                  Home
                </a>
              </li>
              <li data-id="element-127">
                <a href="8.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-128">
                  About Us
                </a>
              </li>
              <li data-id="element-129">
                <a href="66.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-130">
                  FAQ
                </a>
              </li>
              <li data-id="element-131">
                <a href="73.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-132">
                  Newsletter
                </a>
              </li>
              <li data-id="element-133">
                <a href="58.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-134">
                  Industry News
                </a>
              </li>
              <li data-id="element-135">
                <a href="5.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-136">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2: Product Lines */}
          <div data-id="element-137">
            <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-138">
              Product Lines
            </h3>
            <ul className="space-y-2" data-id="element-139">
              <li data-id="element-140">
                <a href="GFMachiningSolutions.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-141">
                  Used AgieCharmilles & Mikron Experts
                </a>
              </li>
              <li data-id="element-142">
                <a href="AgieCharmillesEDM.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-143">
                  AgieCharmilles EDM
                </a>
              </li>
              <li data-id="element-144">
                <a href="MikronHighSpeedMilling.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-145">
                  Mikron High Speed Milling
                </a>
              </li>
              <li data-id="element-146">
                <a href="LaserTexturing.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-147">
                  Laser Texturing
                </a>
              </li>
              <li data-id="element-148">
                <a href="LaserMicromachining.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-149">
                  Laser Micromachining
                </a>
              </li>
              <li data-id="element-150">
                <a href="BretonMachineTools.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-151">
                  Breton Machine Tools
                </a>
              </li>
              <li data-id="element-152">
                <a href="SpinnerMachineTools.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-153">
                  Spinner Milling & Turning
                </a>
              </li>
              <li data-id="element-154">
                <a href="Spinner3_4AxisMilling.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-155">
                  3 & 4-Axis Milling
                </a>
              </li>
              <li data-id="element-156">
                <a href="Spinner5AxisMilling.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-157">
                  5-Axis Milling
                </a>
              </li>
              <li data-id="element-158">
                <a href="SpinnerMultiTurretTurning.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-159">
                  Multi-Turret Turning
                </a>
              </li>
              <li data-id="element-160">
                <a href="SpinnerUltraPrecisionTurning.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-161">
                  Ultra Precision Turning
                </a>
              </li>
              <li data-id="element-162">
                <a href="SpinnerUniversalTurning.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-163">
                  Universal Turning
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: More Products */}
          <div data-id="element-164">
            <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-165">
              More Products
            </h3>
            <ul className="space-y-2" data-id="element-166">
              <li data-id="element-167">
                <a href="Campro_Milling_Turning.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-168">
                  Campro Milling & Turning
                </a>
              </li>
              <li data-id="element-169">
                <a href="CamproUSA3Axis.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-170">
                  3 & 4-Axis Milling
                </a>
              </li>
              <li data-id="element-171">
                <a href="CamproUSA5Axis.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-172">
                  5-Axis Milling
                </a>
              </li>
              <li data-id="element-173">
                <a href="CamproUSABridgeMill.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-174">
                  Double Column Bridge Mill
                </a>
              </li>
              <li data-id="element-175">
                <a href="CamproUSATurning.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-176">
                  Turning Centers
                </a>
              </li>
              <li data-id="element-177">
                <a href="BodorLaserCutting.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-178">
                  Bodor Laser Cutting
                </a>
              </li>
              <li data-id="element-179">
                <a href="BodorLaserPlateCutting.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-180">
                  Fiber Laser Plate Cutter
                </a>
              </li>
              <li data-id="element-181">
                <a href="BodorLaserTubeCutting.html" className="text-blue-100 hover:text-orange transition-colors text-sm ml-3" data-id="element-182">
                  Fiber Laser Tube Cutter
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Services & Categories */}
          <div data-id="element-183">
            <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-184">
              Services & Categories
            </h3>
            <ul className="space-y-2" data-id="element-185">
              <li data-id="element-186">
                <a href="59m7/used-machines.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-187">
                  Used EDM / CNC
                </a>
              </li>
              <li data-id="element-188">
                <a href="QuoteEDMConsumables.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-189">
                  EDM Consumables
                </a>
              </li>
              <li data-id="element-190">
                <a href="Tooling+Automation.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-191">
                  Tooling & Automation
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center" data-id="element-192">
          <p className="text-blue-100 text-sm" data-id="element-193">
            © {currentYear} Peak Machine Sales (Peak EDM Inc.). All rights
            reserved.
          </p>
          <p className="text-blue-100 text-sm mt-4 md:mt-0" data-id="element-194">
            28221 Beck Road, Unit A2, Wixom, MI 48393 •{' '}
            <a href="tel:2483800871" className="hover:text-orange transition-colors" data-id="element-195">
              (248) 380-0871
            </a>
          </p>
        </div>
      </div>
    </footer>;
}